<div class="sprintplanning2view">
  <app-branding-header-bar></app-branding-header-bar>
  <app-informationview [viewName]="'sprintplanning2'"></app-informationview>

  <div class="sp2-grid" [ngClass]="{'transparent-background' : this.backgroundVideoIsActive}">
    <app-product-backlog [statuses]="columnStatuses"></app-product-backlog>

    <div class="sp2board-container">
      <!-- Column-Headings -->
      <div class="sp2__row sp2__row--header">
        <span class="header-left column">{{'actionview.sprintplanning2.sprintbacklog' | translate}}</span>
      </div>

      <!-- Sprintplanning2 view -->
      <div id="actionview" class="actionview">
        <!-- Scroll button left controls -->
        <div class="scroll-button scroll-left" (click)="onScrollButtonClicked(true)">
          <button class="scroll_button" mat-icon-button [disabled]="disableScrollLeftBtn">
            <mat-icon>arrow_back_ios_new</mat-icon>
          </button>
        </div>

        <div id="sp2-column-view" (scroll)="onColumnViewScroll($event)" style="display: flex;"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListConnectedTo]="getConnectedIssues()"
          [cdkDropListData]="issues"
          (cdkDropListDropped)="onIssueDrop($event)"
          (cdkDropListEntered)="onIssueDragListEnter($event)"
          (cdkDropListExited)="onIssueDragListEnterExit($event)">

          <div *ngFor="let issue of issues" cdkDropListGroup cdkDrag
            [cdkDragData]="issue"
            (cdkDragStarted)="onIssueMoveStarted($event)"
            (cdkDragMoved)="onIssueMoved($event)"
            class="issue-column-wrapper">

            <!-- Preview & Placeholder element -->
            <app-sp2-drag-preview [issue]="issue" [type]="'sp2'" *cdkDragPreview></app-sp2-drag-preview>
            <div class="cdk-drag-placeholder-issue" *cdkDragPlaceholder></div>

            <div class="issue-column">
              <app-issue class="issue-list-element teamwidgetdropzone imagedropzone whiteboarddropzone parent-issue-container"
                id='issue-container_{{issue.id}}'
                [issue]="issue"
                [projectKey]="projectKey"
                [statuses]="columnStatuses"
                [inheritedIssueType]="issue.issueType"
                [attr.data-taskcardid]="issue.id"
                [attr.data-highlightcolor]="issue.highlightColor"
                [attr.data-issueid]="issue.id"
                [attr.data-projectkey]="projectKey"
                (issueRemoved)="onIssueRemoved($event)"
              >
              </app-issue>

              <!-- Action buttons -->
              <div class="issue-action-buttons">
                <button mat-flat-button class="sp2-button" (click)="openNewSubissueDialog($event, issue.id)">
                  <span>{{('actionview.taskboard.addSubissue' | translate)}}</span>
                </button>
                <button mat-flat-button class="sp2-button" (click)="splitIssue(issue)">
                  <mat-icon class="icon icon--primary">call_split</mat-icon>
                  <span>{{('actionview.sprintplanning2.splitIssue' | translate)}}</span>
                </button>
              </div>

              <!-- Show all subissues -->
              <div class="sub-issue-container-wrapper" id="story-task-container-id-{{issue.id}}"
                cdkDropList
                [attr.data-issueid]="issue.id"
                [cdkDropListConnectedTo]="getConnectedSubissues()"
                [cdkDropListData]="issue"
                (cdkDropListDropped)="onSubissueDrop($event)">

                <!-- TODO: METHOD call from template, fix for performance! -->
                <app-issue *ngFor="let subissue of issue.tasks" cdkDrag
                  [cdkDragData]="subissue"
                  (cdkDragStarted)="onSubIssueMoveStarted($event)"
                  (cdkDragMoved)="onSubIssueMoved($event)"
                  class="issue-list-element teamwidgetdropzone imagedropzone whiteboarddropzone sub-issue-container"
                  id='subissue-container_{{subissue.id}}'
                  [issue]="subissue"
                  [projectKey]="projectKey"
                  [statuses]="columnStatuses"
                  [inheritedIssueType]="issue.issueType"
                  [attr.data-taskcardid]="subissue.id"
                  [attr.data-highlightcolor]="subissue.highlightColor"
                  [attr.data-issueid]="subissue.id"
                  [attr.data-projectkey]="projectKey"
                  (subIssueRemoved)="onSubIssueRemoved($event)"
                >
                </app-issue>

                <template #newIssueComponent></template>
              </div>
            </div>
          </div>
        </div>
        <!-- Scroll button right controls -->
        <div class="scroll-button scroll-left" (click)="onScrollButtonClicked(false)">
          <button class="scroll_button" mat-icon-button [disabled]="disableScrollRightBtn">
            <mat-icon>arrow_forward_ios</mat-icon>
          </button>
        </div>

      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-footerbar></app-footerbar>

  <div id="popupContainer">
    <ng-template #popupInsertionPoint></ng-template>
  </div>
</div>
